module.exports = "/_next/static/images/6d38a8fb7c7ec96599a8ab4bf3909290-girl-holding-phone@tablet2x.jpg.webp";